export default __webpack_public_path__ + "static/media/clovelly.bca75f72.jpg";